import { Injectable } from "@angular/core";
import { ArticlesApi, ApiArticleFranchise, ApiArticle } from "@tytapp/api";
import { Cache, PagedArray } from "@tytapp/common";

@Injectable()
export class ArticlesService {
    constructor(
        private articlesApi: ArticlesApi,
    ) {
    }

    cache: Cache<ApiArticle> = Cache.shared<ApiArticle>('articles', 1000 * 60 * 15, 100);
    feedCache: Cache<PagedArray<ApiArticle>> = Cache.shared<PagedArray<ApiArticle>>('article-feeds', 1000 * 60 * 15, 20);

    async all(offset?, limit?) {
        return await this.feedCache.fetch(`all-page-${offset}-${limit}`, async skip => {
            return await this.articlesApi.all(offset, limit).toPromise();
        });
    }

    async franchiseFeed(franchiseID, offset?, limit?) {
        return await this.feedCache.fetch(`franchise-${franchiseID}-page-${offset}-${limit}`, async skip => {
            return await this.articlesApi.getArticlesByFranchise(franchiseID, offset, limit).toPromise();
        });
    }

    async latestByFranchise(): Promise<PagedArray<ApiArticleFranchise>> {
        return <any>await this.feedCache.fetch(`latest-by-franchise`, async () => {
            return <any>await this.articlesApi.getLatestByFranchise().toPromise();
        });
    }

    async get(id: string) {
        // No caching on articles until we can reliably determine entitlement app-server-side
        return await this.articlesApi.get(id).toPromise();
    }
}